import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
export default class AllowedCountriesAddon {
  constructor() {
    _defineProperty(this, "CountrySelectEnabled", {
      fieldName: 'is_enabled',
      content: false
    });
    _defineProperty(this, "CountrySelectType", {
      fieldName: 'country_select_type',
      content: null
    });
    _defineProperty(this, "CountrySelectList", {
      fieldName: 'country_select_list',
      content: []
    });
  }
}
_defineProperty(AllowedCountriesAddon, "WHITE_LIST_TYPE", 'white-list');
_defineProperty(AllowedCountriesAddon, "BLACK_LIST_TYPE", 'black-list');